module.exports = __webpack_public_path__ + "static/media/Configuración_Sindicato.38f63fca.svg";